module.exports = "/assets/data/27c01ea241d661de2ab54e06bb341a08-MK1.data.json";